<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :confirm="askConfirm" :title="this.farmer.tostring + ' - ' + $t('New') + ' ' + $t('Audit')"/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-form @submit.stop.prevent="">

            <b-card class="mt-2 mb-4 shadow-sm card-scrollable">
              <h1 class="page-title link ml-1">{{$t('Audit.Practices')}}</h1>
              <div class="mt-1 mb-4 overflow-auto table-container b122-table-container">

                <b-table
                  v-if="audit.practices.length !== 0"
                  ref="b122Table"
                  responsive
                  :items="audit.practices"
                  :fields="tableFields"
                  stacked="lg"
                  empty-title=""
                  empty-text=""
                  show-empty
                  striped
                  borderless
                  sort-icon-left>

                  <template #cell(show)="row">
                    <button class="ph-btn action-btn flex-row justify-content-center align-items-center"
                            @click="clickOnDownloadBtn(row.item.fileUrl)">
                      <i class="ph-custom ph-download-fill"/>
                    </button>
                  </template>

                  <template #cell(actions)="row">
                    <div class="actions-container text-right">
                      <button class="action-btn edit mr-1" @click="clickOnEditPracticeBtn(row)">
                        <i class="ph-custom ph-pencil-simple-line-fill"/>
                      </button>
                      <button class="action-btn delete" @click="clickOnDeletePracticeBtn(row)">
                        <i class="ph-custom ph-trash-fill"/>
                      </button>
                    </div>
                  </template>

                  <template #bottom-row v-if="audit.practices.length < 4">
                    <td v-for="(field) in tableFields" class="empty-row">
                      <div class="no-input">{{ field }}</div>
                    </td>
                  </template>

                  <template #cell(title)="row">
                    {{ row.item.number }} - {{ row.item.title }}
                  </template>


                </b-table>

                <b-button
                  :class="'btn-primary ph-btn show-action-btn mb-1 ' + (audit.practices.length !== 0 ?  'add-practice-btn' : 'mt-3')"
                  variant="primary"
                  @click="clickOnAddPracticeBtn"
                  v-if="audit.practices.length < 4">
                  {{ $t('Add2') + ' ' + $t('a.e') + ' ' + $t('Audit.practice') }}
                </b-button>
              </div>

            </b-card>

            <b-card class="mt-2 mb-4 shadow-sm">
              <div class="d-flex justify-content-between">
                <div class="col-3">
                  {{ $t('Even.if.you.can.put.4.practices') }}
                </div>
                <b-button type="submit" variant="primary" @click="validateAudit"
                          class="btn-primary ph-btn show-action-btn ml-2">
                  {{ $t('Validate.audit') }}
                </b-button>
              </div>
            </b-card>

          </b-form>

        </div>
      </div>

    </b-container>

    <AddOrEditPracticeModal
      ref="addPracticeModal"
      :audit-id="audit.id"
      @refreshPracticeTable="this.fetchInProgressAudit">
    </AddOrEditPracticeModal>

    <b-modal
      id="deleteAssociationModal"
      :cancel-title="$t('Cancel')"
      :ok-title="$t('Remove')"
      :title="$t('Remove') + ' ' + $t('Audit.practice')"
      cancel-variant="primary"
      ok-variant="danger"
      @ok="didDeletePractice()">
      <div class="mb-4">
        {{ $t('Remove') + ' ' + $t('l.e') + ' ' + $t('Audit.practice2') + ' "' + rowSelectedForDeletion.item.title + '" ' +   $t('of.the.audit') + " ?"}}
      </div>
    </b-modal>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import AddOrEditPracticeModal from './AddOrEditPracticeModal.vue'
import {bus} from '../../main'

export default {

  name: 'AuditCreateEdit',

  components: {
    BackArrow,
    AddOrEditPracticeModal
  },

  data () {
    return {
      auditId: this.$route.params.auditId,
      farmerId: this.$route.params.farmerId,
      askConfirm: false,
      audit: {
        practices: []
      },
      farmer: {},
      rowSelectedForDeletion: {
        item: {
          title: ''
        }
      }
    }
  },
  computed: {
    tableFields () {
      return [
        {
          label: '',
          key: 'show',
          sortable: false,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('Practice.title'),
          key: 'title',
          sortable: true,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('Practice.technicianNote'),
          key: 'technicianNote',
          sortable: false,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('Actions'),
          key: 'actions',
          tdClass: 'max-width-cell',
          thClass: 'float-right pr-4'
        }
      ]
    }

  },

  mounted () {
    this.fetchData()
  },

  created () {
    bus.$on('handleSubmit', this.submitCreateEdit)
  },
  beforeDestroy () {
    bus.$off('handleSubmit', this.submitCreateEdit)
  },
  methods: {
    async fetchData () {
      await this.fetchFarmer()
    },

    async fetchFarmer () {
      api
        .get('/farmer/' + this.farmerId)
        .then(response => {
          this.farmer = response.data
          if (!this.farmer.hasInProgressAudit) {
            this.createNewAudit()
          } else {
            this.fetchInProgressAudit()
          }
        })
    },

    createNewAudit () {
      let data = new FormData()
      data.append('farmerId', this.farmer.id)
      api({
        method: 'POST',
        url: '/audit/saveNewAudit',
        data: data
      })
        .then(() => {
          this.successToast(this.$i18n.t('Audit') + ' ' + this.$i18n.t('initialized'))
          this.fetchInProgressAudit()
        })
        .catch((error) => {
          var errorMessage = 'Error'
          if (error.response.status === 403) {
            errorMessage = error.response.data.message
          }
          this.$bvToast.toast(this.$i18n.t(errorMessage), {
            title: this.$i18n.t('Error.title'),
            autoHideDelay: 4000,
            toaster: 'b-toaster-bottom-right',
            solid: true
          })
        })
    },

    fetchInProgressAudit () {
      api
        .get('/audit/getInProgressAuditByFarmer/' + this.farmerId)
        .then(response => {
          this.audit = response.data
          this.$refs.addPracticeModal.practices = this.$refs.addPracticeModal.practices.filter(practiceModal => !this.audit.practices.some(practiceSelected => practiceModal.id === practiceSelected.id))
        })
    },

    validateAudit () {
      let data = new FormData()
      data.append('auditId', this.audit.id)
      api({
        method: 'POST',
        url: '/audit/validateAudit',
        data: data
      })
        .then(() => {
          this.$router.push({
            name: 'FarmerShow',
            params: {
              farmerId: this.farmerId
            }
          },
          () => {
            this.$nextTick(() => {
              this.successToast(this.$i18n.t('Audit') + ' ' + this.$i18n.t('validated'))
            })
          })
        })
        .catch((error) => {
          var errorMessage = 'Error'
          if (error.response.status === 403) {
            errorMessage = error.response.data.message
          }
          this.$bvToast.toast(this.$i18n.t(errorMessage), {
            title: this.$i18n.t('Error.title'),
            autoHideDelay: 4000,
            toaster: 'b-toaster-bottom-right',
            solid: true
          })
        })
    },

    async clickOnDownloadBtn (fileUrl) {
      const res = await api.get(fileUrl, {
        responseType: 'blob'
      })

      var disposition = res.headers['content-disposition'] || ''
      var filename = 'download'

      if (disposition) {
        var match = disposition.match(/filename="?([^"]+)"?/i)
        if (match && match[1]) {
          filename = match[1]
        }
      }

      var blobUrl = window.URL.createObjectURL(res.data)
      var a = document.createElement('a')
      a.href = blobUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(blobUrl)
    },

    clickOnAddPracticeBtn () {
      this.$refs.addPracticeModal.association = null
      this.$refs.addPracticeModal.form.practice.value = ''
      this.$refs.addPracticeModal.form.technicianNote.value = ''
      this.$refs.addPracticeModal.form.practiceSteps = []
      this.$refs.addPracticeModal.practiceSelectedNumber = 0
      this.$refs.addPracticeModal.hasAPracticeBeenSelected = false
      this.$bvModal.show('add-or-edit-practice-modal')
    },

    clickOnEditPracticeBtn (row) {
      this.$refs.addPracticeModal.association = row.item
      this.$refs.addPracticeModal.setInitialValues()
    },

    clickOnDeletePracticeBtn (row) {
      this.rowSelectedForDeletion = row
      this.$bvModal.show('deleteAssociationModal')
    },

    didDeletePractice () {
      let data = new FormData()
      data.append('auditId', this.audit.id)
      data.append('practiceId', this.rowSelectedForDeletion.item.id)
      api({
        method: 'POST',
        url: '/audit/deletePracticeAssociation',
        data: data
      })
        .then(async () => {
          await this.$refs.addPracticeModal.fetchAllPractice()
          this.fetchInProgressAudit()
          this.$bvModal.hide('deleteAssociationModal')
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.errorToast(this.$i18n.t(error.response.data.message))
          } else {
            this.errorToast(this.$i18n.t('Error'))
          }
          this.$bvModal.hide('deleteAssociationModal')
        })
    },

    successToast (message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true
      })
    },

    errorToast (message) {
      this.$bvToast.toast(message, {
        title: this.$i18n.t('Error.title'),
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        solid: true
      })
    }
  }

}
</script>

<style scoped>
/*** Table ***/

.b122-table-container >>> .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(153, 204, 85, 0.2);
}

.b122-table-container >>> th[role="columnheader"] {
  vertical-align: middle;
  color: var(--main-grey);
  font-family: "Museo700", "Arial", sans-serif;
  font-weight: 200;

}

.b122-table-container >>> td[role="cell"] {
  vertical-align: middle;
  color: var(--main-black);
  font-family: "Roboto", "Arial", sans-serif;
}

.b122-table-container >>> .table-striped tbody .b-table-empty-row {
  background-color: white !important;
}

.b122-table-container .no-result {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: grey;
}

.b122-table-container .no-result-text {
  text-align: center;
  max-width: 400px;
}

.b122-table-container .no-result-title {
  color: var(--main-black);
  font-family: "Museo700", "Arial", sans-serif;
}

.b122-table-container .busy {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--main-green-light);
  height: 100px;
  font-size: 1.2em;
}

.b122-table-container >>> td a {
  color: var(--main-grey);
}
</style>

<style>

/*** Actions ***/
.actions-container {
  min-width: 80px;
}

.action-btn {
  background-color: var(--main-green-light);
  border: none;
  height: 32px;
  width: 32px;
  color: var(--main-color-dark);
  border-radius: var(--main-border-radius);
  padding: 6px;
}

.action-btn:hover {
  background-color: var(--main-color-medium);
}

.edit {
  background-color: var(--main-green-light);
  color: var(--main-color-dark);
}

.edit:hover {
  background-color: var(--main-color-medium);
}

.delete {
  background-color: var(--main-red-light);
  color: var(--main-red-dark);
}

.delete:hover {
  background-color: var(--main-red-medium);
}

.table-container {
  overflow-x: scroll;
  align-items: center;
  display: flex;
  flex-direction: column;
}

.table-container::-webkit-scrollbar {
  width: 5px;
}

.table-container::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #ffffff;
}

.float-right {
  float: right;
}

.empty-row {
  height: 56px;
}

.add-practice-btn {
  margin-top: -36px;
}
</style>



// WEBPACK FOOTER //
// src/views/audit/AuditCreateEdit.vue